// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-validation-card {
  margin-bottom: 24px;
}

.bulk-controls {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.bulk-filter-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  max-width: 320px;
}

.bulk-filter-field .form-label {
  min-height: 27px;
  margin-bottom: 4px;
}

.bulk-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.bulk-actions-aligned {
  padding-top: 31px;
}

.branch-fields {
  display: flex;
  gap: 8px;
  align-items: center;
}

.branch-fields select,
.branch-fields input {
  max-width: 180px;
}

.exclusion-select {
  min-width: 260px;
  max-width: 340px;
  padding: 6px 8px;
}

.exclusion-field small {
  display: block;
  min-height: 34px;
  line-height: 1.35;
}

.scope-summary {
  margin-bottom: 16px;
}

.run-history-picker {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.run-history-select {
  width: 360px;
}

.run-progress {
  margin-bottom: 16px;
}

.run-progress-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.run-meta {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
}

.run-counters {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 8px;
  font-size: 0.9rem;
}

.token-summary {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.token-summary mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.counter-link {
  -webkit-appearance: none;
          appearance: none;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
}

.counter-link:disabled {
  cursor: default;
  text-decoration: none;
  opacity: 0.7;
}

.run-current {
  margin-top: 4px;
  font-size: 0.85rem;
}

.run-jobs-table {
  width: 100%;
}

.job-list-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 16px 0 10px;
}

.outcome-filter {
  width: 240px;
}

.outcome-cell {
  max-width: 340px;
  padding-top: 7px;
  padding-bottom: 7px;
}

.outcome-detail {
  max-width: 340px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8rem;
}

.tokens-cell {
  min-width: 110px;
  white-space: nowrap;
}

.token-breakdown {
  margin-top: 2px;
  font-size: 0.75rem;
  line-height: 1.3;
}

.ai-json-button {
  margin-top: 6px;
}

.ai-json-button mat-icon {
  margin-right: 4px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-assessment/bulk-code-validation/bulk-code-validation.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;AACF;;AAEA;EACE,eAAA;EACA,qBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".bulk-validation-card {\n  margin-bottom: 24px;\n}\n\n.bulk-controls {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.bulk-filter-field {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n  max-width: 320px;\n}\n\n.bulk-filter-field .form-label {\n  min-height: 27px;\n  margin-bottom: 4px;\n}\n\n.bulk-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.bulk-actions-aligned {\n  padding-top: 31px;\n}\n\n.branch-fields {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.branch-fields select,\n.branch-fields input {\n  max-width: 180px;\n}\n\n.exclusion-select {\n  min-width: 260px;\n  max-width: 340px;\n  padding: 6px 8px;\n}\n\n.exclusion-field small {\n  display: block;\n  min-height: 34px;\n  line-height: 1.35;\n}\n\n.scope-summary {\n  margin-bottom: 16px;\n}\n\n.run-history-picker {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.run-history-select {\n  width: 360px;\n}\n\n.run-progress {\n  margin-bottom: 16px;\n}\n\n.run-progress-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.run-meta {\n  font-size: 0.875rem;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.run-counters {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n  font-size: 0.9rem;\n}\n\n.token-summary {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.token-summary mat-icon {\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n}\n\n.counter-link {\n  appearance: none;\n  background: none;\n  border: 0;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.counter-link:disabled {\n  cursor: default;\n  text-decoration: none;\n  opacity: 0.7;\n}\n\n.run-current {\n  margin-top: 4px;\n  font-size: 0.85rem;\n}\n\n.run-jobs-table {\n  width: 100%;\n}\n\n.job-list-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 16px 0 10px;\n}\n\n.outcome-filter {\n  width: 240px;\n}\n\n.outcome-cell {\n  max-width: 340px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n\n.outcome-detail {\n  max-width: 340px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.8rem;\n}\n\n.tokens-cell {\n  min-width: 110px;\n  white-space: nowrap;\n}\n\n.token-breakdown {\n  margin-top: 2px;\n  font-size: 0.75rem;\n  line-height: 1.3;\n}\n\n.ai-json-button {\n  margin-top: 6px;\n}\n\n.ai-json-button mat-icon {\n  margin-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
